import React, { useContext } from "react";
import DataContext from "../../../Component/context";
import AccountHeader from "../../../Component/Header/account_header";

const Helpsupport = () => {
    const contextValues = useContext(DataContext)
    const goToMail = (url) => {
        window.open(`mailto:${url}`, '_blank');
    }
    const goToTel = (url) => {
        window.open(`tel:${url}`, '_blank');
    }

    const goToWhatsApp = (url) => {
        window
            .open(url, '_blank')
            .focus();
    }
    return (
        <>
            <AccountHeader heading={'Help & Support'}></AccountHeader>
            <div id="appCapsule">
                <div className="p-5 helpbox text-center">
                    <img className="img-fluid mb-2" src="/img/help.webp" alt="Daadi's Kitchen"></img>
                    <h6>How can we help you today?</h6>
                    <p className="tx-color-02 tx-13 mb-0">
                        Our customer service team will be able to assist you with any order
                        or query
                    </p>
                </div>
                <div className="macc-list">
                    <ul>
                        <li onClick={() => goToMail(contextValues.settingData.admin_support_email)}>
                            <div className="macc-list-icon">
                                <img src="/img/email.png" alt="Daadi's Kitchen" />
                            </div>
                            <div className="macc-list-content">
                                <p className="mb-0 fw600">Email Us</p>
                                <span className="tx-gray tx-11">Write to Daadi's kitchen directly for any query</span>
                            </div>
                            <i className="ri-arrow-right-line"></i>
                        </li> 
                        <li onClick={() => goToTel(contextValues.settingData.admin_support_mobile)}>
                            <div className="macc-list-icon">
                                <img src="/img/hphone.png" alt="Daadi's Kitchen" />
                            </div>
                            <div className="macc-list-content">
                                <p className="mb-0 fw600">Call Us</p>
                                <span className="tx-gray tx-11">Get in touch and we will be happy to help you</span>
                            </div>
                            <i className="ri-arrow-right-line"></i>
                        </li>
                        <li onClick={() => goToWhatsApp(`https://wa.me/${contextValues?.settingData?.admin_support_mobile?.replace(/\s+/g, '')}`)}>
                            <div className="macc-list-icon">
                                <img src="/img/whatsapp.png" alt="Daadi's Kitchen" />
                            </div>
                            <div className="macc-list-content">
                                <p className="mb-0 fw600">Whatsapp</p>
                                <span className="tx-gray tx-11">Get in touch and we will be happy to help you</span>
                            </div>
                            <i className="ri-arrow-right-line"></i>
                        </li>  
                    </ul>
                </div>
            </div>
        </>
    );
};
export default Helpsupport;
